<template>
  <vue-perfect-scrollbar  class="scroll-area">
    <div >

<vs-progress indeterminate color="primary" v-if="isLoading==true"></vs-progress>

<div class="vx-row">
     <div class="vx-col w-full md:w-8/8 lg:w-4/4 mt-12 md:mt-0">
               <v-select :options="unitSelection" placeholder="Select Asset" v-model="selectedUnit" :clearable="false" value="id" label="assetName"  >
<template slot="option" slot-scope="option">
    {{option.assetName}} / {{option.assetGroup}} / {{option.brand}} / {{option.unitId}}
</template>
</v-select>
                    </div>

<br><br>
                       <div class="vx-col w-full md:w-8/8 lg:w-4/4 mt-12 md:mt-0" v-if="commandsLoaded">
               <v-select :options="commands" placeholder="Select Command" v-model="selectedCommand" :clearable="false" value="id" label="name"  >
<template slot="option" slot-scope="option">
    {{option.name}}
</template>
</v-select>
                    </div>
<br>
                            <div class="vx-col w-full md:w-8/8 lg:w-4/4 mt-12 md:mt-0" v-if="commandsLoaded"     v-for="(link, index) in selectedCommand.parameter" :key="index">
<br>
                <vs-input

   :name="link.p"
   :label="link.p"
   v-model="params[index]"
   class="w-full"/>

                    </div>
      <br>
      <div class="vx-row">
       <div class="vx-col w-full md:w-4/8 lg:w-2/4 mt-12 md:mt-0" v-if="commandsLoaded">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-feather"  v-if="commandsLoaded && selectedCommand" size="small" @click="sendCommand">SEND COMMAND (WINDOWS SERVER)</vs-button>

                    </div>

                    <div class="vx-col w-full md:w-4/8 lg:w-2/4 mt-12 md:mt-0" v-if="commandsLoaded">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-feather"  v-if="commandsLoaded && selectedCommand" size="small" @click="sendCommand2">SEND COMMAND (LINUX SERVER)</vs-button>

                    </div>
       </div>


             <br><br>

                       <div class="vx-col w-full md:w-8/8 lg:w-4/4 mt-12 md:mt-0" v-if="commandsLoaded && responseLoaded">
                       <br></br>  <pre id="json">{{response}}</pre>

                    </div>

                    <br><br>

</div>
  <br><br>     <br><br>     <br><br>     <br><br>
    <p class="mb-4" v-if="selectedUnit.model=='gp4000' || selectedUnit.model=='gp6000'">JOINTECH PROTOCOL GP4000-6000 <a href="https://fleets.igeotechgps.com/protocols/GP4000-6000.pdf" target="_blank" rel="nofollow">here</a></p>
     <p class="mb-4" v-if="selectedUnit.model=='gp6000f'">JOINTECH PROTOCOL GP 6000F <a href="https://fleets.igeotechgps.com/protocols/GP6000F.pdf" target="_blank" rel="nofollow">here</a></p>
      <p class="mb-4" v-if="selectedUnit.brand=='starcom'">STARCOM PROTOCOL <a href="https://fleets.igeotechgps.com/protocols/Starcom_EAI.pdf" target="_blank" rel="nofollow">here</a></p>


      <br><br>     <br><br>     <br><br>     <br><br>

      <br><br>     <br><br>     <br><br>     <br><br>

      <br><br>     <br><br>     <br><br>     <br><br>
</div>
  </vue-perfect-scrollbar>



</template>

<script>
import vSelect from 'vue-select'


export default {
  data () {
    return {
      isLoading:false,
      userInfo:JSON.parse(localStorage.getItem('userInfo')),
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      selectedUnit:{},
      selectedCommand:{},
      commands:[],
      commandsLoaded:false,
      response:{},
      responseLoaded:false,
      params:[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]


    }
  },
  components: {
    vSelect
  },
  watch: {
    selectedUnit (val) {
      this.getCommands(val.brand)
      this.selectedCommand = {}
      this.response = {}
      this.responseLoaded = false
    },

    selectedCommand (val) {
      this.selectedCommand.parameter = JSON.parse(this.selectedCommand.parameter)
    }

  },
  methods:{
    sendCommand () {
      try {
        const self = this
        const brand = self.selectedUnit.brand
        const unitId = self.selectedUnit.unitId
        const params = {}
        const nFunction = self.selectedCommand.nFunction
        self.isLoading = true
        self.responseLoaded = false
        self.response = {}

        self.$http.post('/admin/commands', {
          brand,
          unitId,
          params,
          nFunction,
          p1:self.params[0],
          p2:self.params[1],
          p3:self.params[2],
          p4:self.params[3],
          p5:self.params[4],
          p6:self.params[5],
          p7:self.params[6],
          p8:self.params[7],
          p9:self.params[8],
          p10:self.params[9],
          p11:self.params[10],
          p12:self.params[11],
          p13:self.params[12],
          p14:self.params[13]

        })
          .then(function (response) {
            self.isLoading = false

            if (response.status == 200 && response.data.success) {
              self.$vs.notify({
                title: 'Command Response',
                text: 'Response received.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              self.responseLoaded = true
              self.response = response.data
              /*    if(brand=='jointech'){
            self.response = 'Response: '+response.data.results.msgAscii;
          }
          if(brand=='starcom'){
            self.response = 'Response: '+response.data.results.msg;
          }
          if(brand=='teltonika'){
            self.response = 'Response: '+response.data.results[0].data.message.data;
          }*/
              //   self.response = response.data.results;
            } else {
              self.responseLoaded = true
              if (response.data.error) {
                self.$vs.notify({
                  title: 'Error',
                  text: 'Try again later.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })

              } else {
                self.$vs.notify({
                  title: 'Error',
                  text: 'Try again later.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })
              }
            }
          })
          .catch(function (error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })


      } catch (error) {
        console.error(error)
      }

    },
    sendCommand2 () {
      try {
        const self = this
        const brand = self.selectedUnit.brand
        const unitId = self.selectedUnit.unitId
        const params = {}
        const nFunction = self.selectedCommand.nFunction
        self.isLoading = true
        self.responseLoaded = false
        self.response = {}

        self.$http.post('/admin/commands2', {
          brand,
          unitId,
          params,
          nFunction,
          p1:self.params[0],
          p2:self.params[1],
          p3:self.params[2],
          p4:self.params[3],
          p5:self.params[4],
          p6:self.params[5],
          p7:self.params[6],
          p8:self.params[7],
          p9:self.params[8],
          p10:self.params[9],
          p11:self.params[10],
          p12:self.params[11],
          p13:self.params[12],
          p14:self.params[13]

        })
          .then(function (response) {
            self.isLoading = false

            if (response.status == 200 && response.data.success) {
              self.$vs.notify({
                title: 'Command Response',
                text: 'Response received.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              self.responseLoaded = true

              if(self.selectedUnit.brand=='jointech' && response.data.results.data[0].success==true){
                  self.response = response.data.results.data[0].results;
              }
              else if(self.selectedUnit.brand=='starcom' && response.data.results.data[0].success==true){
                  self.response = response.data.results.data[0].results;
              }
              else if(self.selectedUnit.brand=='teltonika' && response.data.results.data[0].success==true){
                  self.response = response.data.results.data[0].results;
              }
              else {
                self.response = response.data.results
              }
            } else {
              self.responseLoaded = true
              if (response.data.error) {
                self.$vs.notify({
                  title: 'Error',
                  text: 'Try again later.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })

              } else {
                self.$vs.notify({
                  title: 'Error',
                  text: 'Try again later.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })
              }
            }
          })
          .catch(function (error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })


      } catch (error) {
        console.error(error)
      }

    },
    getCommands (brand) {
      const self = this
      self.commands = []
      self.commandsLoaded = false
      self.$http.get(`admin/commands/${brand}`, {

      })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {

            self.commands = response.data.commands
            self.commandsLoaded = true


          } else if (response.data.error) {


          } else {

          }
        })
        .catch(function (error) {

        })
    }
  },
  mounted () {

  }
}
</script>
<style>

@import "../../../node_modules/@syncfusion/ej2-vue-layouts/styles/material.css";
@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
</style>
